(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['./footerView', 'app/ereg/footer/eregFooterView'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('./footerView'), require('./../ereg/footer/eregFooterView'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (footerView, eregFooterView) {
  'use strict';

  /**
   * Static footer views for portal and ereg.
   *
   * @class footerViews
   * @static
   */
  return {
    /**
     * @property portal {footerView} static footer view tailored to experience in patient-portal.
     */
    portal: footerView,

    /**
     * @property patient {eregFooterView} static footer view tailored to experience in ereg.
     */
    ereg: eregFooterView
  };
}));
